export const useCustomer = () => useState<object>('customer', () => ({}));